import { render, staticRenderFns } from "./GoodsInspirationEdit.vue?vue&type=template&id=a4ecc2ea&"
import script from "./GoodsInspirationEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsInspirationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports